import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store'
import { type IResponseCallEnded } from 'entities/Call/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IEventHandlerOptions } from 'entities/Call/events/types'

export const useEventCallEnded = (options?: IEventHandlerOptions) => {
  const { websocket, callStore, usersStore } = useEntitiesContext()
  const user = usersStore.user

  const handle = (data: IResponseCallEnded) => {
    if (options?.enabled && !options.enabled()) return
    if (user?.id !== data.user_id) return

    callStore.endCallFromServer(data.call_sid)
  }

  useEffect(() => websocket.on(WebsocketEvent.CallEnded, handle), [callStore, user])
}
